import React, { memo, useCallback, useContext, useState } from 'react'
import '../../../../styles/sortableData.scss'
import CloseIcon from '@mui/icons-material/Close'
import TableDataPagination, { INITIAL_ROWS_PER_PAGE } from '../../../../pages/Products/components/TableDataPagination'
import { DataContratosContext } from '../../context/data.contratos.context'
import { format } from 'date-fns'
import { Button, useMediaQuery, useTheme } from '@mui/material'
import { deleteLinks } from '../../services/admin.local.services'
import ConfirmDialog from '../../../../pages/Products/components/ConfirmDialog'
import SnackBarUtils from '../../../../utils/SnackBarUtils'
import { PropsDataContratos } from '../Pagos/ModalTablePagos'
import CardsLinks from './CardsLinks'

const ModalTableLinks: React.FC<PropsDataContratos> = ({
  show,
  loading,
  data,
  handleClose,
  headers,
  title,
  codLocal
}: PropsDataContratos) => {
  const showHideClassName = show ? 'modal display-block' : 'modal display-none'
  const { paginatorLinks, setPageLinks, setPageSizeLinks, pageLinks, pageSizeLinks } = useContext(DataContratosContext)
  const [confirmDialog, setConfirmDialog] = useState<any>({
    open: false,
    text: {
      title: '',
      body: '',
      leftButton: 'Cancelar',
      rightButton: 'Confirmar',
      colorButtonConfirm: 'primary'
    },
    action: async () => {}
  })
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const clearConfirmDialog = () => {
    setConfirmDialog((confirmDialog: any) => ({
      ...confirmDialog,
      open: false
    }))
  }

  paginatorLinks.handleChangePage = (e: any, newPage: number) => {
    setPageLinks(newPage)
  }

  paginatorLinks.handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setPageSizeLinks(parseInt(event.target.value, 10))
    setPageLinks(0)
  }

  const closeRenovations = () => {
    handleClose()
  }

  const handleDelete = useCallback(() => {
    setConfirmDialog({
      open: true,
      text: {
        title: 'Se van a invalidar todos los links no utilizados del local',
        body: '¿Deseas continuar?',
        leftButton: 'Cancelar',
        rightButton: 'Continuar',
        colorButtonConfirm: 'error'
      },
      action: async () => {
        try {
          deleteLinks(codLocal).then((res) => {
            SnackBarUtils.success(res.data.message)
          })
        } catch {
          console.log()
        } finally {
          clearConfirmDialog()
          closeRenovations()
        }
      },
      close: () => {
        clearConfirmDialog()
      }
    })
  }, [codLocal])

  if (loading || !codLocal) return

  return (
    <>
      {isMobile ? (
        <CardsLinks
          show={show}
          loading={loading}
          data={data}
          handleClose={handleClose}
          headers={headers}
          title={title}
          handleDelete={handleDelete}
        />
      ) : (
        <div className={showHideClassName}>
          <section
            className="modal-main"
            style={{
              marginTop: '20px',
              overflowY: 'auto',
              maxHeight: '80vh'
            }}
          >
            <header
              className="contract-actions-header"
              style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}
            >
              <h3 className="contract-actions-title">{title !== undefined && title}</h3>
              <div
                style={{
                  display: 'flex',
                  gap: isMobile ? '5px' : '10px',
                  justifyContent: 'flex-end',
                  marginRight: isMobile ? '50px' : '30px'
                }}
              >
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDelete}
                  size={isMobile ? 'small' : 'medium'}
                  style={{ ...(isMobile && { padding: '1px 6px', marginTop: '2px' }) }}
                >
                  Eliminar links del local
                </Button>
                <button className="modal-close" onClick={closeRenovations} aria-label="Cerrar">
                  <CloseIcon />
                </button>
              </div>
            </header>
            <div style={{ paddingRight: '7.5vh' }}>
              <table className="table table-striped table-bordered premise-table">
                <thead className="table-active">
                  <tr>
                    {headers &&
                      headers.map((h: any, index) => {
                        return (
                          <th key={index}>
                            <button
                              type="button"
                              // onClick={() => requestSort("idContrato")}
                              // className={getClassNamesFor("idContrato")}
                            >
                              {h}
                            </button>
                          </th>
                        )
                      })}
                  </tr>
                </thead>
                {data.items.length > 0 && (
                  <tbody>
                    {data.items.map((item: any, index) => {
                      const fechaAlta = new Date(item.fechaAlta)
                      const fechaVencimiento = new Date(item.fechaVencimiento)
                      return (
                        <tr key={item.idContratoPagoLink}>
                          <th>{item.idContratoPagoLink}</th>
                          <th>{<th>{format(fechaAlta, 'dd/MM/yyyy HH:mm:ss')}</th>}</th>
                          <th>{format(fechaVencimiento, 'dd/MM/yyyy HH:mm:ss')}</th>
                          <th>{item.platform}</th>
                          <th>{item.source?.nombre ?? String(item.source)}</th>
                          <th>{item.tienePagos ? 'SI' : 'NO'}</th>
                          <th style={{ maxWidth: '400px' }}>{item.link}</th>
                        </tr>
                      )
                    })}
                  </tbody>
                )}
                <tfoot>
                  <tr>
                    <TableDataPagination
                      total={data.totalItems || 0}
                      page={pageLinks || 0}
                      paginator={paginatorLinks}
                      items={data.items || []}
                      rowsPerPage={pageSizeLinks || INITIAL_ROWS_PER_PAGE}
                      label={`Links por página`}
                    />
                  </tr>
                </tfoot>
              </table>
            </div>
          </section>
        </div>
      )}
      <ConfirmDialog {...confirmDialog} />
    </>
  )
}

export default memo(ModalTableLinks)
